import React, { useEffect, useRef, useState } from "react";
import FormDropDown from "../../../forms/DropDownList/FormDropDown";
import "./ExpeditionControls.scss";
import { convertMSToHMS } from "../../../../helpers/Dates";
import TabbedPanel from "../../../TabbedPanel/TabbedPanel";
import EXPEDITION_LIVE_STATE from "./ExpeditionLiveState";
import Toggle from "../../../forms/Toggle/Toggle";
import HMSTimeField from "../../../forms/HMSTimeField/HMSTimeField";
import { LatLongDisplay } from "./LatLongDisplay";

const timeoutIds = {};
const ExpeditionControls = (props) => {
    // A state variable to cause an update every second so we can show the live time
    const [tick, setTick] = useState(0);
    const [buttonClickedWaitingForUpdate, setButtonClickedWaitingForUpdate] = useState(false);

    useEffect(() => {
        setButtonClickedWaitingForUpdate(false);
    }, [props]);
    useEffect(() => {
        if (buttonClickedWaitingForUpdate) {
            clearTimeout(timeoutIds.buttonClickedWaitingForUpdate);
            timeoutIds.buttonClickedWaitingForUpdate = setTimeout(() => {
                setButtonClickedWaitingForUpdate(false);
            }, 1000);
        }
    }, [buttonClickedWaitingForUpdate]);

    const expeditionDataFetched = props.expeditionDataFetched;

    const primaryStream = props.featureVars.manageExpeditionControls.masterStream;
    const yourTeam = props.featureVars.manageExpeditionControls.selectedTeam;

    const getStateData = () => {
        let stateData = null;
        if (props.previewControls && props?.passedInPreviewData?.expeditionState) {
            stateData = props.passedInPreviewData.expeditionState;
        }
        if (!props.previewControls && expeditionDataFetched) {
            stateData = EXPEDITION_LIVE_STATE.expeditionMainState;
        }
       /*  if (stateData === null) {
            stateData = props?.featureVars?.expeditionState;
        } */
        if (stateData) {
            // console.log('--- ExpeditionControls, stateData: ', stateData);
            return stateData;
        }
        // Default state data
        return {
            expeditionInited: false,
        };
    }

    const getOverlaysStateData = () => {
        let overlaysStateData = null;
        if (props.previewControls && props?.passedInPreviewData?.activeOverlays) {
            overlaysStateData = props.passedInPreviewData.activeOverlays;
        }
        if (overlaysStateData === null) {
            overlaysStateData = props?.featureVars?.activeOverlays;
        }
        if (overlaysStateData) {
            return overlaysStateData;
        }
        return {
            alerts: [],
            teamStats: [],
        };
    }

    const updateReceivedCallback = (newExpeditionState, sentData) => {
        // console.log('--- ExpeditionControls, updateReceivedCallback: ', data);
        setTick((tick) => tick + 1);
    }
    useEffect(() => {
        const interval = setInterval(() => {
            setTick((tick) => tick + 1);
        }, 1000);
        EXPEDITION_LIVE_STATE.registerUpdateListener(updateReceivedCallback);
        console.log('--- ExpeditionControls, useEffect (mounted)', props);
        return () => {
            clearInterval(interval);
            EXPEDITION_LIVE_STATE.unregisterUpdateListener(updateReceivedCallback);
        }
    }, []);

    const stateData = getStateData();
    const overlaysStateData = getOverlaysStateData();
    const streamOverlayActive = overlaysStateData?.streamOverlayActive === true;
    // const HMSTotalTime = convertMSToHMS(Date.now() - stateData.featureStartTime, true);

    const featureIdForCommands = props.previewControls ? 'previewFrame' : props.featureId;

    useEffect(() => {
        // If the expedition state has changed, and we were waiting for an update, stop waiting
        if (buttonClickedWaitingForUpdate) {
            setButtonClickedWaitingForUpdate(false);
        }
    }, [stateData.expeditionInited, stateData.expeditionActive, stateData.expeditionStartTime]);
    
    const getDisplayFormattedTime = (timeInMS) => {
        if (timeInMS <= 0) return '00:00:00';
        const timeObj = convertMSToHMS(timeInMS, true);
        return `${timeObj.h}:${timeObj.m_str}:${timeObj.s_str}`;
    }

    const getTeamDropdownListData = () => {
        const listData = [];
        if (props.customisationData?.setup?.teams?.teams && props.customisationData.setup.teams.teams.length > 0) {
            for (let i = 0; i < props.customisationData.setup.teams.teams.length; i++) {
                listData.push({value: i, label: props.customisationData.setup.teams.teams[i].name});
            }
        }
        return listData;
    }
    const teamsListData = getTeamDropdownListData();

    const [selectedTeamIndex, setSelectedTeamIndex] = useState(0);
    const [teamData, setTeamData] = useState(null);
    const [memberData, setMemberData] = useState(null);
    // If the teams change, and our selected team index is now out of range, reset it to 0
    useEffect(() => {
        if (selectedTeamIndex >= teamsListData.length) {
            setSelectedTeamIndex(0);
        }
        setTeamData(props.customisationData?.setup?.teams?.teams?.[selectedTeamIndex] || null);
        const teamMembers = props.customisationData?.setup?.teamMembers?.teamMembers?.filter((member) => {
            return member.team === selectedTeamIndex;
        }) ?? null;
        setMemberData(teamMembers);
        // console.log('--- ExpeditionControls, teamData: ', teamData, memberData);
    }, [selectedTeamIndex, props.customisationData]);

    const [currentTab, setCurrentTab] = useState(0);

    const [autoShowTeamStatusAfterHero, setAutoShowTeamStatusAfterHero] = useState(false);
    const [autoShowDelay, setAutoShowDelay] = useState(10);

    const teamState = stateData.teamStates ? stateData.teamStates[selectedTeamIndex] : null;

    const journeyData = props.customisationData?.setup['journey' + (teamData?.journey + 1 ?? 1)];
    const journeyStagesCount = journeyData ? (journeyData.stages ? journeyData.stages.length : 0) : 0;
    const routeData = props.customisationData?.setup['route' + (journeyData?.stages[teamState?.journeyStage]?.route + 1 ?? 1)];
    const routeWaypointsCount = routeData ? (routeData.waypoints.length > 0 ? routeData.waypoints.length : 0) : 0;

    const isOnFinalJourneyStage = teamState?.journeyStage === (journeyStagesCount - 1);

    const hasReachedEndOfStage = teamState?.currentWaypoint > routeWaypointsCount;
    const wayPointsReachedFlags = [];
    for (let i = 0; i < routeWaypointsCount; i++) {
        wayPointsReachedFlags.push(teamState?.currentWaypoint > i);
    }
    const checkpointToDisplay = hasReachedEndOfStage ? teamState?.journeyStage + 1 : teamState?.journeyStage;

    const selectedTeamHeroBannerActiveOverlay = overlaysStateData.teamStats.find((overlay) => {
        return overlay.isHero === true && overlay.teamIndex === selectedTeamIndex;
    });
    const canShowHeroBanner = !selectedTeamHeroBannerActiveOverlay ? true : false;
    const canHideHeroBanner = selectedTeamHeroBannerActiveOverlay ? true : false;

    const selectedTeamStatsActiveOverlay = overlaysStateData.teamStats.find((overlay) => {
        return overlay.isHero !== true && overlay.teamIndex === selectedTeamIndex;
    });
    const canShowStatsBanner = !selectedTeamStatsActiveOverlay ? true : false;
    const canHideStatsBanner = selectedTeamStatsActiveOverlay ? true : false;

    // console.log('--- ExpeditionControls: ', overlaysStateData);
    const waypointAlertActiveOverlay = overlaysStateData.alerts.find((overlay) => {
        return overlay.type === 'waypoint_reached_alert' && overlay.teamIndex === selectedTeamIndex;
    });
    const canAdvanceWaypoint_preview = stateData.expeditionActive && !waypointAlertActiveOverlay && teamState?.currentWaypoint <= routeWaypointsCount ? true : false;

    const isItemAlertOverlayActive = (itemIndex) => {
        const itemAlert = overlaysStateData.alerts.find((overlay) => {
            return overlay.type === 'item_used_alert' && overlay.teamIndex === selectedTeamIndex && overlay.itemIndex === itemIndex;
        });
        return itemAlert ? true : false;
    }

    // Challenges, each route consists of two challenges, one at the start and one at the end
    // A challenge is only available if we are on the first or last waypoint of a route
    // Completed challenges are stored in teamState.endedChallenges[] with a challengeIndex
    // The active challenge can be a number in which case we have to look it up or it can be an object with challengeIndex, startedTime and completedTime
    // If the active challenge is a number we need to look for a seperate challengeStartTime property in our expeditionState
    const startChallengeIndex = routeData?.routeSetup?.[0]?.startChallenge ?? 0;
    const startChallengeData = props.customisationData?.setup?.challenges?.challenges?.[startChallengeIndex] || null;
    const startChallengeIsACheckpoint = startChallengeData?.emptyChallenge === true;
    const startChallengeAvailable = !startChallengeIsACheckpoint && stateData.expeditionActive && stateData.expeditionStartTime > 0 && teamState?.currentWaypoint === 0 ? true : false;
    let startChallengeActive = typeof teamState?.activeChallenge === 'number' ? (teamState.activeChallenge === startChallengeIndex ? true : false) : (teamState?.activeChallenge?.challengeIndex === startChallengeIndex ? true : false);
    let startChallengeStartedTime = 0;
    if (startChallengeActive) {
        startChallengeStartedTime = typeof teamState?.activeChallenge === 'number' ? (teamState?.activeChallengeStartTime ?? 0) : (teamState?.activeChallenge?.startedTime ?? 0);
    }
    let startChallengeEnded = false;
    let startChallengeSuccessful = false;
    let startChallengeEndedTime = 0;
    if (teamState?.endedChallenges && teamState.endedChallenges.length > 0) {
        const startChallengeState = teamState.endedChallenges.find((challenge) => challenge.challengeIndex === startChallengeIndex);
        if (startChallengeState) {
            startChallengeEnded = true;
            startChallengeSuccessful = startChallengeState.successful;
            startChallengeStartedTime = startChallengeState.startedTime;
            startChallengeEndedTime = startChallengeState.completedTime;
        }
    }
    let startChallengeColourCss = '';
    let startChallengeStatusColourCss = ' ch-available-to-start-text';
    let startChallengeStatusText = primaryStream ? 'Available to Start' : 'Only the Primary Stream can start this';
    if (!startChallengeAvailable) {
        startChallengeColourCss = ' not-currently-available';
        startChallengeStatusText = 'Not Currently Available';
    }
    if (startChallengeAvailable && startChallengeActive && startChallengeStartedTime > 0) {
        startChallengeColourCss = ' in-progress';
        startChallengeStatusText = 'In Progress';
        startChallengeStatusColourCss = ' attention-text';
    }
    if (startChallengeEnded && startChallengeSuccessful) {
        startChallengeColourCss = ' completed';
        startChallengeStatusText = 'Completed Successfully';
        startChallengeStatusColourCss = ' confirm-text';
    }
    if (startChallengeEnded && !startChallengeSuccessful) {
        startChallengeColourCss = ' failed';
        startChallengeStatusText = 'Failed';
        startChallengeStatusColourCss = ' warning-text';
    }


    const endChallengeIndex = routeData?.routeSetup?.[0]?.endChallenge ?? 0;
    const endChallengeData = props.customisationData?.setup?.challenges?.challenges?.[endChallengeIndex] || null;
    const endChallengeIsACheckpoint = endChallengeData?.emptyChallenge === true;
    const endChallengeAvailable = !endChallengeIsACheckpoint && teamState?.currentWaypoint === routeWaypointsCount + 1 ? true : false;
    let endChallengeActive = typeof teamState?.activeChallenge === 'number' ? (teamState.activeChallenge === endChallengeIndex ? true : false) : (teamState?.activeChallenge?.challengeIndex === endChallengeIndex ? true : false);
    let endChallengeStartedTime = 0;
    if (endChallengeActive) {
        endChallengeStartedTime = typeof teamState?.activeChallenge === 'number' ? (teamState?.activeChallengeStartTime ?? 0) : (teamState?.activeChallenge?.startedTime ?? 0);
    }
    let endChallengeEnded = false;
    let endChallengeSuccessful = false;
    let endChallengeEndedTime = 0;
    if (teamState?.endedChallenges && teamState.endedChallenges.length > 0) {
        const endChallengeState = teamState.endedChallenges.find((challenge) => challenge.challengeIndex === endChallengeIndex);
        if (endChallengeState) {
            endChallengeEnded = true;
            endChallengeSuccessful = endChallengeState.successful;
            endChallengeStartedTime = endChallengeState.startedTime;
            endChallengeEndedTime = endChallengeState.completedTime;
        }
    }
    let endChallengeColourCss = '';
    let endChallengeStatusColourCss = '';
    let endChallengeStatusText = primaryStream ? 'Available to Start' : 'Only the Primary Stream can start this';
    if (!endChallengeAvailable) {
        endChallengeColourCss = ' not-currently-available';
        endChallengeStatusText = 'Not Currently Available';
    }
    if (endChallengeAvailable && endChallengeActive && endChallengeStartedTime > 0) {
        endChallengeColourCss = ' in-progress';
        endChallengeStatusText = 'In Progress';
        endChallengeStatusColourCss = ' attention-text';
    }
    if (endChallengeEnded && endChallengeSuccessful) {
        endChallengeColourCss = ' completed';
        endChallengeStatusText = 'Completed Successfully';
        endChallengeStatusColourCss = ' confirm-text';
    }
    if (endChallengeEnded && !endChallengeSuccessful) {
        endChallengeColourCss = ' failed';
        endChallengeStatusText = 'Failed';
        endChallengeStatusColourCss = ' warning-text';
    }

    let nextTarget = null;
    if ((teamState?.currentWaypoint ?? 0) < routeWaypointsCount) {
        nextTarget = routeData.waypoints[teamState?.currentWaypoint ?? 0];
    } else {
        nextTarget = endChallengeData;
    }

    const [compassLockTime, setCompassLockTime] = useState(props.featureVars?.expeditionMessagesControls?.compassLockTime ?? 120);
    const isCompassLockedOverlayActive = () => {
        const compassLockAlert = overlaysStateData.alerts.find((overlay) => {
            return overlay.type === 'compass_frozen_alert' && overlay.teamIndex === selectedTeamIndex;
        });
        return compassLockAlert ? true : false;
    }

    const outOfTime = stateData.expeditionCompletedTime === 0 && stateData.expeditionTargetEndTime > 0 && (Date.now() / 1000) >= stateData.expeditionTargetEndTime;
    const expeditionCompleted = stateData.expeditionCompletedTime > 0;
    const teamCompletedExpedition = teamState?.expeditionCompleted === true;

    // Quite an if statement!
    let canBacktrackJourney = primaryStream && stateData && stateData.expeditionInited && stateData.expeditionActive && stateData.expeditionStartTime > 0 && stateData.teamStates && stateData.teamStates.length > 0 && (stateData.teamStates[selectedTeamIndex].journeyStage > 0 || stateData.teamStates[selectedTeamIndex].currentWaypoint > 0);
    let backtrackJourneyStageTo = canBacktrackJourney && stateData?.teamStates?.[selectedTeamIndex]?.currentWaypoint === 0 ? stateData.teamStates[selectedTeamIndex].journeyStage - 1 : stateData?.teamStates?.[selectedTeamIndex]?.journeyStage ?? 0;
    let backTrackWaypointTo = stateData?.teamStates?.[selectedTeamIndex]?.currentWaypoint > 0 ? stateData?.teamStates?.[selectedTeamIndex]?.currentWaypoint - 1 : -1;
    if (backTrackWaypointTo === -1 && backtrackJourneyStageTo >= 0) {
        backTrackWaypointTo =  props.customisationData?.setup['route' + (journeyData?.stages?.[backtrackJourneyStageTo]?.route + 1)]?.waypoints?.length + 1 ?? 0;
    }
    if (canBacktrackJourney && (backtrackJourneyStageTo < 0 || backTrackWaypointTo < 0)) {
        canBacktrackJourney = false;
    }
    let canAdvanceWaypoint_live = primaryStream && stateData.expeditionInited && stateData.expeditionActive && stateData.expeditionStartTime > 0 && stateData.teamStates && stateData.teamStates.length > 0 && teamState && routeData && teamState.currentWaypoint <= routeWaypointsCount + 1 && !outOfTime && !expeditionCompleted && !teamCompletedExpedition;

    const advanceWaypoint_live = () => {
        if (canAdvanceWaypoint_live && primaryStream && stateData.expeditionActive) {
            const nextWaypoint = teamState.currentWaypoint + 1;
            if (nextWaypoint > routeWaypointsCount + 1) {
                const nextJourneyStage = teamState.journeyStage + 1;
                if (nextJourneyStage < journeyStagesCount) {
                    EXPEDITION_LIVE_STATE.silentlySetJourneyStageForTeam(selectedTeamIndex, nextJourneyStage, 0, null);
                } else {
                    return;
                }
            } else
            if (nextWaypoint > routeWaypointsCount) {
                EXPEDITION_LIVE_STATE.checkpointReachedForTeam(selectedTeamIndex, teamState.journeyStage, routeWaypointsCount + 1, endChallengeIndex);
            } else {
                EXPEDITION_LIVE_STATE.waypointReachedForTeam(selectedTeamIndex, teamState.journeyStage, nextWaypoint);
            }
        }
    }

    return (
        <div className="generic-feature-status fl-column" style={{marginBottom: '-2rem'}}>
            {!stateData.expeditionInited &&
                <>
                    <div className={`generic-feature-status-main-header inactive`}>
                        - Not Ready -
                    </div>
                    <div className="light-text bold-text">Use the Manage Expedition Controls to get up and running.</div>
                    <div></div>
                </>
            }
            
            {stateData.expeditionInited && 
                <>
                    {stateData.expeditionActive && stateData.expeditionStartTime > 0 &&
                        <>
                            {!outOfTime && !expeditionCompleted && 
                                <div className={`generic-feature-status-main-header active`}>- Running: {getDisplayFormattedTime((stateData.expeditionTargetEndTime - Math.floor(Date.now() / 1000)) * 1000)} -</div>
                            }
                            {outOfTime && !expeditionCompleted && !teamCompletedExpedition &&
                                <div className={`generic-feature-status-main-header inactive`}>- Out of Time -</div>
                            }
                            {expeditionCompleted && 
                                <div className={`generic-feature-status-main-header active`}>- Expedition Completed -</div>
                            }
                        </>
                    }
                    {(!stateData.expeditionActive || !stateData.expeditionStartTime) &&
                        <>
                            <div className={`generic-feature-status-main-header warning`}>
                                - Not Running -
                            </div>
                            <div className="light-text bold-text">You will only have limited functionality until your expedition is started.</div>
                        </>
                    }
                    <FormDropDown
                        label={"Select Team To View"}
                        items={teamsListData}
                        value={selectedTeamIndex}
                        selectFunc={
                            (e, id, item) => {
                                setSelectedTeamIndex(item.value);
                                // props.setFunc(item.index)
                                // props.changeValFunc('pollControl', 'selectedPollType', pollTypes[item.index]);
                            }
                        }
                        currentIndex={selectedTeamIndex}
                        showErrors={false}
                        enabled={teamsListData.length > 0}
                    />
                    <div className="fl-column no-gap">
                        <div className="fl-row">
                            <div className={`expoc-team-name bold-text ${(primaryStream || yourTeam === selectedTeamIndex) ? 'confirm-text' : 'warning-text'}`}>{teamsListData[selectedTeamIndex]?.label}</div>
                            <div className="grow"></div>
                            <div className={`bold-text ${(primaryStream || yourTeam === selectedTeamIndex) ? 'confirm-text' : 'warning-text'}`}>{stateData?.teamStates[selectedTeamIndex]?.totalXp}xp</div>
                        </div>
                        {!primaryStream &&
                            <div className="fl-row">
                                {yourTeam !== selectedTeamIndex &&
                                    <div className="expoc-team-name bold-text warning-text">Beware: This is not your team!</div>
                                }
                                {yourTeam === selectedTeamIndex &&
                                    <div className="expoc-team-name bold-text confirm-text">This is your team.</div>
                                }
                            </div>
                        }
                    </div>
                    <div className="normal-body-text-colour">
                        <TabbedPanel
                            tabs={[{label: "Team"}, {label: "Journey"}/* , {label: "Items"} */]}
                            selectedTab={0}
                            switchTabCallback={(index) => setCurrentTab(index)}
                        >
                            <div className="expoc-demargin-tab-content">
                                {currentTab === 0 && 
                                    <div className="fl-column">
                                        <div className="fl-row bold-text">
                                            <div className="expoc-team-name">{teamsListData[selectedTeamIndex]?.label} Members:</div>
                                        </div>
                                        <div className="fl-column no-gap">
                                            {memberData && memberData.length > 0 &&
                                                memberData.map((member, index) => {
                                                    return (
                                                        <div key={index} className={`fl-row expoc-pad-row${index % 2 === 0 ? ' expoc-alternating-row' : ''}`}>
                                                            <div className="expoc-team-member-image" style={{ backgroundImage: `url(${member.heroImage?.srcUrl ?? (member.heroImage.isDefault ? props.defaultAssetBaseUrl + 'image/' + member.heroImage?.filename : props.customAssetBaseUrl + 'image/' + member.heroImage?.filename)})` }}></div>
                                                            <div className="grow"></div>
                                                            <div className="bold-text">{member.name}</div>
                                                            <div className="grow"></div>
                                                            <div className="bold-text">{member.twitchHandle}</div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    {streamOverlayActive &&
                                        <>
                                            <hr />
                                            <div className={`fl-column tight`}>
                                                <div className={`fl-column no-gap`}>
                                                    <div className={`fl-row`}>
                                                        <div className="form-field-content label">Auto Show Status After Hero</div>
                                                        <div className="grow-100"></div>
                                                        <div className="form-field-content label">Delay</div>
                                                    </div>
                                                    <div className={`fl-row`}>
                                                        <Toggle
                                                            id={'autoShowTeamStatus'}
                                                            currentState={autoShowTeamStatusAfterHero}
                                                            toggleFunc={(e, id) => { setAutoShowTeamStatusAfterHero(!autoShowTeamStatusAfterHero) }}
                                                            enabled={true}
                                                        />
                                                        <div className="grow-100"></div>
                                                        <div style={{ marginRight: '-1rem', pointerEvents: autoShowTeamStatusAfterHero ? 'auto' : 'none', opacity: autoShowTeamStatusAfterHero ? 1 : 0.5 }}>
                                                            <HMSTimeField
                                                                label={"Delay"}
                                                                showLabel={false}
                                                                id={"autoShowDelay"}
                                                                value={autoShowDelay}
                                                                setFunc={setAutoShowDelay}
                                                                showHours={false}
                                                                showMinutes={false}
                                                                showSeconds={true}
                                                                showError={false}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="button-grid">
                                                    {(canShowHeroBanner || !primaryStream) &&
                                                        <button className={`standard-button ${buttonClickedWaitingForUpdate ? 'button-inactive' : ''}`} onClick={buttonClickedWaitingForUpdate ? null : () => {
                                                            setButtonClickedWaitingForUpdate(true);
                                                            props.sendFeatureCommandFunc(null, "SHOW_TEAM_HERO_BANNER", featureIdForCommands, { teamIndex: selectedTeamIndex, autoShowTeamStatusAfterHero, autoShowDelay });
                                                        }}>
                                                            Show Team Hero Banner
                                                        </button>
                                                    }
                                                    {(canHideHeroBanner || !primaryStream) &&
                                                        <button className={`standard-button ${buttonClickedWaitingForUpdate ? 'button-inactive' : 'live-but-red'}`} onClick={buttonClickedWaitingForUpdate ? null : () => {
                                                            setButtonClickedWaitingForUpdate(true);
                                                            props.sendFeatureCommandFunc(null, "HIDE_TEAM_HERO_PANEL", featureIdForCommands, { teamIndex: selectedTeamIndex });
                                                        }}>
                                                            Hide Team Hero Banner
                                                        </button>
                                                    }
                                                </div>
                                            </div>
                                        </>
                                    }

                                    </div>
                                }
                                {currentTab === 1 &&
                                    <div className="fl-column">
                                        {routeData &&
                                        <>
                                            <div className="fl-column no-gap bold-text">
                                                <div className="fl-row"><div className="light-text">Journey:</div><div className="grow"></div><div>{(journeyData?.journeySetup?.[0]?.name ?? 'Unknown')}</div></div>
                                                <div className="fl-row"><div className="light-text">Current Route:</div><div className="grow"></div><div>{(routeData?.routeSetup?.[0]?.name ?? 'Unknown')}</div></div>
                                                <div className="fl-row"><div className="light-text">Checkpoint:</div><div className="grow"></div><div>{checkpointToDisplay}/{journeyStagesCount}</div></div>
                                                <div className="fl-row"><div className="light-text">Location:</div><div className="grow"></div><div><LatLongDisplay latitude={teamState?.latitude} longitude={teamState?.longitude} /></div></div>
                                                <div className="fl-row"><div className="light-text">Next Target:</div><div className="grow"></div><div><LatLongDisplay latitude={nextTarget?.latitude} longitude={nextTarget?.longitude} /></div></div>
                                            </div>

                                            {startChallengeData &&
                                                <div className={`quest-challenge-container${startChallengeColourCss}`}>
                                                    <div className="fl-row grow">
                                                        <div className={`var-label${!startChallengeAvailable ? ' light-text' : ''}`}>Route Start:</div>
                                                        <div className="grow"></div>
                                                        {!startChallengeIsACheckpoint &&
                                                            <div className={`var-label${!startChallengeAvailable ? ' light-text' : ''}`}>{startChallengeData.name}{startChallengeData.pointsChallenge && startChallengeData.xp > 0 && <> ({startChallengeData.xp}xp)</>}</div>
                                                        }
                                                        {startChallengeIsACheckpoint &&
                                                            <div className={`var-label${!startChallengeAvailable ? ' light-text' : ''}`}>{startChallengeData.name}</div>
                                                        }
                                                    </div>
                                                    <div className="fl-row grow">
                                                        <div className="grow"></div>
                                                        <LatLongDisplay latitude={startChallengeData?.latitude} longitude={startChallengeData?.longitude} />
                                                    </div>
                                                    {!startChallengeIsACheckpoint &&
                                                    <>
                                                        <div className="fl-row grow">
                                                            <div className={`bold-text${!startChallengeAvailable ? ' light-text' : ''}${startChallengeStatusColourCss}`}>{startChallengeStatusText}</div>
                                                            <div className="grow"></div>
                                                            {startChallengeData.timedChallenge &&
                                                                <>
                                                                    {(!startChallengeActive || startChallengeStartedTime === 0) && !startChallengeEnded &&
                                                                        <div className={`bold-text${!startChallengeAvailable ? ' light-text' : ''}`}>{getDisplayFormattedTime(startChallengeData.time * 1000)}</div>
                                                                    }
                                                                    {startChallengeActive && !startChallengeEnded && startChallengeStartedTime > 0 &&
                                                                        <div className="bold-text">{getDisplayFormattedTime(startChallengeData.time * 1000 - (Date.now() - startChallengeStartedTime * 1000))}</div>
                                                                    }
                                                                    {startChallengeEnded &&
                                                                        <div className="bold-text">{getDisplayFormattedTime(startChallengeData.time * 1000 - (startChallengeEndedTime - startChallengeStartedTime) * 1000)}</div>
                                                                    }
                                                                </>
                                                            }
                                                            {!startChallengeData.timedChallenge &&
                                                                <div className="light-text">Untimed</div>
                                                            }
                                                        </div>
                                                        <div className="button-grid">
                                                            <button className={`standard-button ${!buttonClickedWaitingForUpdate && startChallengeAvailable && (!startChallengeActive || startChallengeStartedTime === 0) && !startChallengeEnded && primaryStream ? 'live-but-green' : 'button-inactive'}`}
                                                                onClick={
                                                                    !buttonClickedWaitingForUpdate && startChallengeAvailable && (!startChallengeActive || startChallengeStartedTime === 0) && !startChallengeEnded && primaryStream ? () => {
                                                                        setButtonClickedWaitingForUpdate(true);
                                                                        if (props.previewControls) {
                                                                            props.sendFeatureCommandFunc(null, "PREVIEW_START_CHALLENGE", featureIdForCommands, { teamIndex: selectedTeamIndex, challengeIndex: startChallengeIndex, startTime: Math.floor(Date.now() / 1000) });
                                                                        } else {
                                                                            EXPEDITION_LIVE_STATE.startChallengeForTeam(selectedTeamIndex, startChallengeIndex);
                                                                        }
                                                                    } : null
                                                                }
                                                            >
                                                                Start Challenge
                                                            </button>
                                                            <button className={`standard-button ${!buttonClickedWaitingForUpdate && startChallengeAvailable && (startChallengeActive && startChallengeStartedTime > 0) && !startChallengeEnded && primaryStream ? 'live-but-red' : 'button-inactive'}`}
                                                                onClick={
                                                                    !buttonClickedWaitingForUpdate && startChallengeAvailable && (startChallengeActive && startChallengeStartedTime > 0) && !startChallengeEnded && primaryStream ? () => {
                                                                        setButtonClickedWaitingForUpdate(true);
                                                                        if (props.previewControls) {
                                                                            props.sendFeatureCommandFunc(null, "PREVIEW_FAIL_CHALLENGE", featureIdForCommands, { teamIndex: selectedTeamIndex, challengeIndex: startChallengeIndex, endTime: Math.floor(Date.now() / 1000) });
                                                                        } else {
                                                                            EXPEDITION_LIVE_STATE.challengeCompletedForTeam(selectedTeamIndex, startChallengeIndex, false, teamState.journeyStage, false, 0);
                                                                        }
                                                                    } : null
                                                                }
                                                            >
                                                                Fail
                                                            </button>
                                                            <button className={`standard-button ${!buttonClickedWaitingForUpdate && startChallengeAvailable && (startChallengeActive && startChallengeStartedTime > 0) && !startChallengeEnded && primaryStream ? 'live-but-green' : 'button-inactive'}`}
                                                                onClick={
                                                                    !buttonClickedWaitingForUpdate && startChallengeAvailable && (startChallengeActive && startChallengeStartedTime > 0) && !startChallengeEnded && primaryStream ? () => {
                                                                        setButtonClickedWaitingForUpdate(true);
                                                                        if (props.previewControls) {
                                                                            props.sendFeatureCommandFunc(null, "PREVIEW_COMPLETE_CHALLENGE", featureIdForCommands, { teamIndex: selectedTeamIndex, challengeIndex: startChallengeIndex, endTime: Math.floor(Date.now() / 1000) } );
                                                                        } else {
                                                                            EXPEDITION_LIVE_STATE.challengeCompletedForTeam(selectedTeamIndex, startChallengeIndex, true, teamState.journeyStage, false, startChallengeData.pointsChallenge ? startChallengeData.xp : 0);
                                                                        }
                                                                    } : null
                                                                }
                                                            >
                                                                Complete
                                                            </button>
                                                        </div>
                                                    </>
                                                    }
                                                </div>
                                            }

                                            <div className="fl-row">
                                                <div className='quest-route-line-holder'>
                                                    {teamState.currentWaypoint === 0 &&
                                                        <div className='quest-route-current-waypoint' onMouseEnter={(e) => props.showTooltipFunc(startChallengeData.name, e)} onMouseLeave={props.hideTooltipFunc}>
                                                            <div className='quest-route-current-waypoint-inner'></div>
                                                        </div>
                                                    }
                                                    {teamState.currentWaypoint > 0 && 
                                                        <div className='quest-route-past-checkpoint' onMouseEnter={(e) => props.showTooltipFunc(startChallengeData.name, e)} onMouseLeave={props.hideTooltipFunc}></div>
                                                    }
                                                    {wayPointsReachedFlags.map((reached, index) => (
                                                        <React.Fragment key={index}>
                                                            <div className={`quest-route-line-${reached ? 'solid' : 'dashed'}`}></div>
                                                            {reached && teamState.currentWaypoint - 1 > index &&
                                                                <div className='quest-route-complete-waypoint' onMouseEnter={(e) => props.showTooltipFunc(`Name: ${routeData.waypoints[index].name}, ID: ${routeData.waypoints[index].id}`, e)} onMouseLeave={props.hideTooltipFunc}></div>
                                                            }
                                                            {reached && teamState.currentWaypoint - 1 === index &&
                                                                <div className='quest-route-current-waypoint' onMouseEnter={(e) => props.showTooltipFunc(`Name: ${routeData.waypoints[index].name}, ID: ${routeData.waypoints[index].id}`, e)} onMouseLeave={props.hideTooltipFunc}>
                                                                    <div className='quest-route-current-waypoint-inner'></div>
                                                                </div>
                                                            }
                                                            {!reached &&
                                                                <div className='quest-route-future-waypoint' onMouseEnter={(e) => props.showTooltipFunc(`Name: ${routeData.waypoints[index].name}, ID: ${routeData.waypoints[index].id}`, e)} onMouseLeave={props.hideTooltipFunc}></div>
                                                            }
                                                        </React.Fragment>
                                                    ))}
                                                    <div className={`quest-route-line-${hasReachedEndOfStage ? 'solid' : 'dashed'}`}></div>
                                                    {hasReachedEndOfStage &&
                                                        <div className='quest-route-current-waypoint' onMouseEnter={(e) => props.showTooltipFunc(endChallengeData.name, e)} onMouseLeave={props.hideTooltipFunc}>
                                                            <div className='quest-route-current-waypoint-inner'></div>
                                                        </div>
                                                    }
                                                    {!hasReachedEndOfStage &&
                                                        <div className='quest-route-checkpoint' onMouseEnter={(e) => props.showTooltipFunc(endChallengeData.name, e)} onMouseLeave={props.hideTooltipFunc}></div>
                                                    }
                                                </div>
                                            </div>

                                            {endChallengeData &&
                                                <div className={`quest-challenge-container${endChallengeColourCss}`}>
                                                    <div className="fl-row grow">
                                                        <div className={`var-label${!endChallengeAvailable ? ' light-text' : ''}`}>Route End:</div>
                                                        <div className="grow"></div>
                                                        {!endChallengeIsACheckpoint &&
                                                            <div className={`var-label${!endChallengeAvailable ? ' light-text' : ''}`}>{endChallengeData.name}{endChallengeData.pointsChallenge && endChallengeData.xp > 0 && <> ({endChallengeData.xp}xp)</>}</div>
                                                        }
                                                        {endChallengeIsACheckpoint &&
                                                            <div className={`var-label${!endChallengeAvailable ? ' light-text' : ''}`}>{endChallengeData.name}</div>
                                                        }
                                                    </div>
                                                    <div className="fl-row grow">
                                                        <div className="grow"></div>
                                                        <LatLongDisplay latitude={endChallengeData?.latitude} longitude={endChallengeData?.longitude} />
                                                    </div>
                                                    {!endChallengeIsACheckpoint &&
                                                        <>
                                                            <div className="fl-row grow">
                                                                <div className={`bold-text${!endChallengeAvailable ? ' light-text' : ''}${endChallengeStatusColourCss}`}>{endChallengeStatusText}</div>
                                                                <div className="grow"></div>
                                                                {endChallengeData.timedChallenge &&
                                                                    <>
                                                                        {(!endChallengeActive || endChallengeStartedTime === 0) && !endChallengeEnded &&
                                                                            <div className={`bold-text${!endChallengeAvailable ? ' light-text' : ''}`}>{getDisplayFormattedTime(endChallengeData.time * 1000)}</div>
                                                                        }
                                                                        {endChallengeActive && !endChallengeEnded && endChallengeStartedTime > 0 &&
                                                                            <div className="bold-text">{getDisplayFormattedTime(endChallengeData.time * 1000 - (Date.now() - endChallengeStartedTime * 1000))}</div>
                                                                        }
                                                                        {endChallengeEnded &&
                                                                            <div className="bold-text">{getDisplayFormattedTime(endChallengeData.time * 1000 - (endChallengeEndedTime - endChallengeStartedTime) * 1000)}</div>
                                                                        }
                                                                    </>
                                                                }
                                                                {!endChallengeData.timedChallenge &&
                                                                    <div className="light-text">Untimed</div>
                                                                }
                                                            </div>
                                                            <div className="button-grid">
                                                                <button className={`standard-button ${!buttonClickedWaitingForUpdate && endChallengeAvailable && (!endChallengeActive || endChallengeStartedTime === 0) && !endChallengeEnded && primaryStream ? 'live-but-green' : 'button-inactive'}`}
                                                                    onClick={
                                                                        !buttonClickedWaitingForUpdate && endChallengeAvailable && (!endChallengeActive || endChallengeStartedTime === 0) && !endChallengeEnded && primaryStream ? () => {
                                                                            setButtonClickedWaitingForUpdate(true);
                                                                            if (props.previewControls) {
                                                                                props.sendFeatureCommandFunc(null, "PREVIEW_START_CHALLENGE", featureIdForCommands, { teamIndex: selectedTeamIndex, challengeIndex: endChallengeIndex, startTime: Math.floor(Date.now() / 1000) } );
                                                                            } else {
                                                                                EXPEDITION_LIVE_STATE.startChallengeForTeam(selectedTeamIndex, endChallengeIndex);
                                                                            }
                                                                        } : null
                                                                    }
                                                                >
                                                                    Start Challenge
                                                                </button>
                                                                <button className={`standard-button ${!buttonClickedWaitingForUpdate && endChallengeAvailable && endChallengeActive && endChallengeStartedTime > 0 && !endChallengeEnded && primaryStream ? 'live-but-red' : 'button-inactive'}`}
                                                                    onClick={
                                                                        !buttonClickedWaitingForUpdate && endChallengeAvailable && endChallengeActive && endChallengeStartedTime > 0 && !endChallengeEnded && primaryStream ? () => {
                                                                            setButtonClickedWaitingForUpdate(true);
                                                                            if (props.previewControls) {
                                                                                props.sendFeatureCommandFunc(null, "PREVIEW_FAIL_CHALLENGE", featureIdForCommands, { teamIndex: selectedTeamIndex, challengeIndex: endChallengeIndex, endTime: Math.floor(Date.now() / 1000) } );
                                                                            } else {
                                                                                EXPEDITION_LIVE_STATE.challengeCompletedForTeam(selectedTeamIndex, endChallengeIndex, false, isOnFinalJourneyStage ? teamState.journeyStage : teamState.journeyStage + 1, isOnFinalJourneyStage, 0);
                                                                            }
                                                                        } : null
                                                                    }
                                                                >
                                                                    Fail
                                                                </button>
                                                                <button className={`standard-button ${!buttonClickedWaitingForUpdate && endChallengeAvailable && endChallengeActive && endChallengeStartedTime > 0 && !endChallengeEnded && primaryStream ? 'live-but-green' : 'button-inactive'}`}
                                                                    onClick={
                                                                        !buttonClickedWaitingForUpdate && endChallengeAvailable && endChallengeActive && !endChallengeEnded && primaryStream ? () => {
                                                                            setButtonClickedWaitingForUpdate(true);
                                                                            if (props.previewControls) {
                                                                                props.sendFeatureCommandFunc(null, "PREVIEW_COMPLETE_CHALLENGE", featureIdForCommands, { teamIndex: selectedTeamIndex, challengeIndex: endChallengeIndex, endTime: Math.floor(Date.now() / 1000) } );
                                                                            } else {
                                                                                EXPEDITION_LIVE_STATE.challengeCompletedForTeam(selectedTeamIndex, endChallengeIndex, true, isOnFinalJourneyStage ? teamState.journeyStage : teamState.journeyStage + 1, isOnFinalJourneyStage, endChallengeData.pointsChallenge ? endChallengeData.xp : 0);
                                                                            }
                                                                        } : null
                                                                    }
                                                                >
                                                                    Complete
                                                                </button>
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                            }
                                        </>
                                        }
                                        {!routeData &&
                                            <div className="bold-text warning-text">No route data found for this team&apos;s current journey stage</div>
                                        }

                                        {props.previewControls &&
                                        <>

                                            <div className="bold-text attention-text">Preview Mode: Live Mode controls may vary.</div>

                                            <div className="button-grid">
                                                <button className={`standard-button ${!buttonClickedWaitingForUpdate && canAdvanceWaypoint_preview && (yourTeam === selectedTeamIndex || primaryStream) ? 'live-but-green' : 'button-inactive'}`} 
                                                    onClick={!buttonClickedWaitingForUpdate && canAdvanceWaypoint_preview && (yourTeam === selectedTeamIndex || primaryStream) && stateData.expeditionActive ? () => {
                                                        setButtonClickedWaitingForUpdate(true);
                                                        props.sendFeatureCommandFunc(null, "ADVANCE_TEAM_WAYPOINT", featureIdForCommands, selectedTeamIndex);
                                                    } : null}
                                                >
                                                    Advance Journey
                                                </button>
                                                {(canShowStatsBanner || !primaryStream) &&
                                                    <button className={`standard-button ${buttonClickedWaitingForUpdate ? 'button-inactive' : ''}`} 
                                                        onClick={!buttonClickedWaitingForUpdate ? () => {
                                                            setButtonClickedWaitingForUpdate(true);
                                                            props.sendFeatureCommandFunc(null, "SHOW_TEAM_STATS", featureIdForCommands, selectedTeamIndex);
                                                        } : null}
                                                    >
                                                        Show Team Status Banner
                                                    </button>
                                                }
                                                {(canHideStatsBanner || !primaryStream) &&
                                                    <button className={`standard-button ${buttonClickedWaitingForUpdate ? 'button-inactive' : 'live-but-red'}`} 
                                                        onClick={!buttonClickedWaitingForUpdate ? () => {
                                                            setButtonClickedWaitingForUpdate(true);
                                                            props.sendFeatureCommandFunc(null, "HIDE_TEAM_STATS", featureIdForCommands, selectedTeamIndex);
                                                        } : null}
                                                    >
                                                        Hide Team Status Banner
                                                    </button>
                                                }
                                            </div>

                                            {stateData.expeditionInited && stateData.expeditionActive &&
                                                <>
                                                    <hr />

                                                    {!outOfTime && !expeditionCompleted && !teamCompletedExpedition &&
                                                        <div className="fl-column no-gap">
                                                            <div className="label">Freeze Compass For {teamsListData[selectedTeamIndex]?.label} For</div>
                                                            <div className="fl-row">
                                                                <div className="shrink" style={{marginLeft: '-1rem', marginRight: '-1rem'}}>
                                                                    <HMSTimeField
                                                                        label={"Lock Compass For"}
                                                                        id={'compassLockTime'}
                                                                        setFunc={(newVal) => { setCompassLockTime(newVal); props.featureVars.expeditionMessagesControls.compassLockTime = newVal; }}
                                                                        value={compassLockTime}
                                                                        showError={false}
                                                                        showHours={false}
                                                                        showLabel={false}
                                                                    />
                                                                </div>
                                                                <div className="button-grid" style={{width: '100%', marginBottom: 0}}>
                                                                    <button className={`standard-button ${(buttonClickedWaitingForUpdate || isCompassLockedOverlayActive()) ? 'button-inactive' : 'live-but-red'}`} style={{width: '100%'}} onClick={(buttonClickedWaitingForUpdate || isCompassLockedOverlayActive()) ? null : () => {
                                                                        setButtonClickedWaitingForUpdate(true);
                                                                        if (props.previewControls) {
                                                                            props.sendFeatureCommandFunc(null, "PREVIEW_FREEZE_COMPASS", featureIdForCommands, {duration: compassLockTime, teamIndex: selectedTeamIndex});
                                                                        } else {
                                                                            EXPEDITION_LIVE_STATE.freezeCompass(compassLockTime);
                                                                        }
                                                                    }}>
                                                                        Freeze Compass Now
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                    {outOfTime && !teamCompletedExpedition &&
                                                        <div className="bold-text warning-text">Team failed the expedition - time expired.</div>
                                                    }
                                                    {teamCompletedExpedition &&
                                                        <div className="bold-text confirm-text">Team completed the expedition in {getDisplayFormattedTime((teamState.expeditionCompletedTime - stateData.expeditionStartTime) * 1000)}</div>
                                                    }
                                                </>
                                            }

                                        </>
                                        }

                                        {!props.previewControls &&
                                        <>

                                            <div className="button-grid">
                                                <button className={`standard-button ${!buttonClickedWaitingForUpdate && canBacktrackJourney && (yourTeam === selectedTeamIndex || primaryStream) ? 'live-but-red' : 'button-inactive'}`} 
                                                    onClick={!buttonClickedWaitingForUpdate && canBacktrackJourney && (yourTeam === selectedTeamIndex || primaryStream) && stateData.expeditionActive ? () => {
                                                        setButtonClickedWaitingForUpdate(true);
                                                        // props.sendFeatureCommandFunc(null, "ADVANCE_TEAM_WAYPOINT", featureIdForCommands, selectedTeamIndex);
                                                        EXPEDITION_LIVE_STATE.silentlySetJourneyStageForTeam(selectedTeamIndex, backtrackJourneyStageTo, backTrackWaypointTo, null);
                                                    } : null}
                                                >
                                                    Backtrack Journey
                                                </button>
                                                <button className={`standard-button ${!buttonClickedWaitingForUpdate && canAdvanceWaypoint_live && (yourTeam === selectedTeamIndex || primaryStream) ? 'live-but-green' : 'button-inactive'}`} 
                                                    onClick={!buttonClickedWaitingForUpdate && canAdvanceWaypoint_live && (yourTeam === selectedTeamIndex || primaryStream) && stateData.expeditionActive ? () => {
                                                        setButtonClickedWaitingForUpdate(true);
                                                        // props.sendFeatureCommandFunc(null, "ADVANCE_TEAM_WAYPOINT", featureIdForCommands, selectedTeamIndex);
                                                        advanceWaypoint_live();
                                                    } : null}
                                                >
                                                    Advance Journey
                                                </button>
                                                {(canShowStatsBanner || !primaryStream) &&
                                                    <button className={`standard-button ${buttonClickedWaitingForUpdate ? 'button-inactive' : ''}`} 
                                                        onClick={!buttonClickedWaitingForUpdate ? () => {
                                                            setButtonClickedWaitingForUpdate(true);
                                                            props.sendFeatureCommandFunc(null, "SHOW_TEAM_STATS", featureIdForCommands, selectedTeamIndex);
                                                        } : null}
                                                        style={{minWidth: '100%'}}
                                                    >
                                                        Show Team Status Banner
                                                    </button>
                                                }
                                                {(canHideStatsBanner || !primaryStream) &&
                                                    <button className={`standard-button ${buttonClickedWaitingForUpdate ? 'button-inactive' : 'live-but-red'}`} 
                                                        onClick={!buttonClickedWaitingForUpdate ? () => {
                                                            setButtonClickedWaitingForUpdate(true);
                                                            props.sendFeatureCommandFunc(null, "HIDE_TEAM_STATS", featureIdForCommands, selectedTeamIndex);
                                                        } : null}
                                                        style={{minWidth: '100%'}}
                                                    >
                                                        Hide Team Status Banner
                                                    </button>
                                                }
                                            </div>

                                            {stateData.expeditionInited && stateData.expeditionActive &&
                                                <>
                                                    <hr />

                                                    {!outOfTime && !expeditionCompleted && !teamCompletedExpedition &&
                                                        <div className="fl-column no-gap">
                                                            <div className="label">Freeze Compass For {teamsListData[selectedTeamIndex]?.label} For</div>
                                                            <div className="fl-row">
                                                                <div className="shrink" style={{marginLeft: '-1rem', marginRight: '-1rem'}}>
                                                                    <HMSTimeField
                                                                        label={"Lock Compass For"}
                                                                        id={'compassLockTime'}
                                                                        setFunc={(newVal) => { setCompassLockTime(newVal); props.featureVars.expeditionMessagesControls.compassLockTime = newVal; }}
                                                                        value={compassLockTime}
                                                                        showError={false}
                                                                        showHours={false}
                                                                        showLabel={false}
                                                                    />
                                                                </div>
                                                                <div className="button-grid" style={{width: '100%', marginBottom: 0}}>
                                                                    <button className={`standard-button ${(buttonClickedWaitingForUpdate || isCompassLockedOverlayActive()) ? 'button-inactive' : 'live-but-red'}`} style={{width: '100%'}} onClick={(buttonClickedWaitingForUpdate || isCompassLockedOverlayActive()) ? null : () => {
                                                                        setButtonClickedWaitingForUpdate(true);
                                                                        // props.sendFeatureCommandFunc(null, "PREVIEW_FREEZE_COMPASS", featureIdForCommands, {duration: compassLockTime, teamIndex: selectedTeamIndex});
                                                                        EXPEDITION_LIVE_STATE.freezeComapassForTeam(compassLockTime, selectedTeamIndex);
                                                                    }}>
                                                                        Freeze Compass Now
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                    {outOfTime && !teamCompletedExpedition &&
                                                        <div className="bold-text warning-text">Team failed the expedition - time expired.</div>
                                                    }
                                                    {teamCompletedExpedition &&
                                                        <div className="bold-text confirm-text">Team completed the expedition in {getDisplayFormattedTime((teamState.expeditionCompletedTime - stateData.expeditionStartTime) * 1000)}</div>
                                                    }
                                                </>
                                            }

                                        </>
                                        }

                                    </div>
                                }
                                {currentTab === 2 && 
                                    <div className="fl-column">
                                        <div className="fl-column no-gap">
                                            {stateData?.teamStates?.[selectedTeamIndex]?.inventory && stateData.teamStates?.[selectedTeamIndex]?.inventory.length > 0 &&
                                                stateData.teamStates?.[selectedTeamIndex]?.inventory.map((item, index) => {
                                                    const itemData = props.customisationData.setup.inventory.items?.[item.itemIndex];
                                                    if (!itemData) return null;
                                                    return (<div key={index} className={`fl-row expoc-pad-row${index % 2 === 0 ? ' expoc-alternating-row' : ''}`}>
                                                        <div className="expoc-team-item-image" style={{ backgroundImage: `url(${itemData.image.srcUrl})` }}></div>
                                                        <div className="button-grid">
                                                            <button className={`standard-button ${(!buttonClickedWaitingForUpdate && streamOverlayActive && (yourTeam === selectedTeamIndex || primaryStream) && stateData.expeditionActive && !isItemAlertOverlayActive(index)) ? 'live-but-green' : 'button-inactive'}`} 
                                                                onClick={(!buttonClickedWaitingForUpdate && streamOverlayActive && (yourTeam === selectedTeamIndex || primaryStream) && stateData.expeditionActive && !isItemAlertOverlayActive(index)) ? () => {
                                                                    setButtonClickedWaitingForUpdate(true);
                                                                    props.sendFeatureCommandFunc(null, "SHOW_ITEM_USED_ALERT", featureIdForCommands, {teamIndex: selectedTeamIndex, itemIndex: index});
                                                                } : null}
                                                            >
                                                                Use {itemData.name}
                                                            </button>
                                                        </div>
                                                    </div>)
                                                })
                                            }
                                            {(!stateData?.teamStates?.[selectedTeamIndex]?.inventory || stateData.teamStates?.[selectedTeamIndex]?.inventory.length === 0) &&
                                                <div className="bold-text warning">No items in inventory</div>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        </TabbedPanel>
                    </div>
                </>
            }
            {/*!streamOverlayActive && stateData.expeditionInited &&
            <>
                <div className="bold-text warning-text" style={{marginTop: '1rem'}}>Note: The Expedition Stream Overlay is not currently active. You will have limited functionality until you show it.</div>
                <div className="button-grid">
                    <button className="standard-button live-but-green" onClick={() => {
                        props.sendFeatureCommandFunc(null, "START_FEATURE", featureIdForCommands, 0);
                    }}>
                        Show Stream Overlay
                    </button>
                </div>
            </>
            */}
        </div>
    )
}

export default ExpeditionControls;
